// extracted by mini-css-extract-plugin
module.exports = {"Container":"Ribbon_Container__ys1Ox","Content":"Ribbon_Content___xlyS","Caption":"Ribbon_Caption__PJRyd Ribbon_Content___xlyS","Title":"Ribbon_Title__ymUpP Ribbon_Content___xlyS"};